// extracted by mini-css-extract-plugin
export default {"stylesNode":"CompanyTree_stylesNode__HxcU9","miniplusBtn":"CompanyTree_miniplusBtn__SoQnP","miniMinusBtn":"CompanyTree_miniMinusBtn__FaW8I"};